const INITIAL_STATE = { signedOn: null, failure: null, loading: false, userRole: null };

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_STARTED/USER_IDENTITY":
            return { ...state, loading: true };
        case "SUBSCRIPTION_DATA_ARRIVED/USER_IDENTITY":
            return { ...action.payload, failure: null, loading: false };
        case "SUBSCRIPTION_INITIAL_DATA_FAILED/USER_IDENTITY":
            return { signedOn: null, failure: action.payload, loading: false };
        case "SUBSCRIPTION_DATA_FAILED/USER_IDENTITY":
            return { ...state, failure: action.payload };
        case "AUTHENTICATION_FAILED":
            return { ...state, signedOn: false };
        default:
            return state;
    }
}